/** Query value for `listing_type` — online store products vs individual classified ads. */
export type ListingTypeFilter = 'stores' | 'classifieds';

export const LISTING_TYPE_FILTER_OPTIONS = [
  { value: 'stores' as const, label: 'Online Store', description: 'Only online store products' },
  { value: 'classifieds' as const, label: 'Classifieds', description: 'Only classified listings' },
] as const;

/** Accepts a single query value or Next.js App Router `searchParams` shape. */
export function parseListingTypeFromSearchParams(
  raw: string | string[] | undefined,
): ListingTypeFilter | undefined {
  const single = Array.isArray(raw) ? raw[0] : raw;
  const v = (single ?? '').trim().toLowerCase();
  if (v === 'stores' || v === 'online_stores' || v === 'store') return 'stores';
  if (v === 'classifieds' || v === 'classified' || v === 'ads') return 'classifieds';
  return undefined;
}
